import MoreCode from "!!raw-loader!./togglebuttons/More.tsx";
import NonExclusiveCode from "!!raw-loader!./togglebuttons/NonExclusive.tsx";
import OneCode from "!!raw-loader!./togglebuttons/One.tsx";
import TwoCode from "!!raw-loader!./togglebuttons/Two.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import More from "./togglebuttons/More";
import NonExclusive from "./togglebuttons/NonExclusive";
import One from "./togglebuttons/One";
import Two from "./togglebuttons/Two";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("One Button", OneCode, One),
		paneComponent("Two Buttons", TwoCode, Two),
		paneComponent("More Buttons", MoreCode, More),
		paneComponent("Non-Exclusive Buttons", NonExclusiveCode, NonExclusive, "A non-exclusive toggle button group's value is an array of strings rather than a single string value."),
	];

	return (
		<Pane
			components={components}
			imports='import {ToggleButton, ToggleButtonGroup} from "designSystem/index";'
			muiApi="toggle-button"
			muiComponent="toggle-button"
			{...props}
		/>
	);
};